import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c6bce5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-result-body" }
const _hoisted_2 = { class: "navigation-button" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 検索結果に戻る ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuthorInfo = _resolveComponent("AuthorInfo")!
  const _component_RelatedItems = _resolveComponent("RelatedItems")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SideMenu = _resolveComponent("SideMenu")!
  const _component_ToPageTop = _resolveComponent("ToPageTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_AuthorInfo, { authorInfo: _ctx.authorInfo }, null, 8, ["authorInfo"]),
        _createVNode(_component_RelatedItems, {
          works: _ctx.works,
          "onUpdate:works": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.works) = $event)),
          worksNum: _ctx.worksNum,
          "onUpdate:worksNum": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.worksNum) = $event))
        }, null, 8, ["works", "worksNum"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: {
            path: '/openinq/search',
            query: _ctx.openinqSearch,
            force: true
          },
            class: "button-back"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DssIcon, {
                icon: "arrow-left",
                style: {"font-size":"18px"}
              }),
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createVNode(_component_SideMenu)
    ]),
    _createVNode(_component_ToPageTop)
  ], 64))
}